//in this file we put all the variables that are constants and are reused across the project.

// the goal of this file is that it will allow us to easily configure our project by simply changing some of the data that is here in the configuration file.

export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes';

export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
